//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometryBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"ArcSpan",1,0],[0,"LockAngle",1,0],[0,"LockRadius",1,0],[1,"Radius",0,"Expression",0]],[[["centerPoint"],"SetCenterPoint",{},1,0],[["centerPoint"],"SnapCenterPoint",{},1,0],[["sizePoint"],"SetSizePoint",{},1,0],[["sizePoint"],"SnapSizePoint",{},1,0],[["sweepPoint"],"SetSweepPoint",{},1,0],[["sweepPoint"],"SnapSweepPoint",{},1,0]],[]];
SPLM.SketchArcFromCenterBuilder = class extends SPLM.SketchGeometryBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchArcFromCenterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchArcFromCenterBuilder.ArcSpanType = Object.freeze({
    "Minor" : "Minor", "Major" : "Major"});

export default SPLM;